import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalDesktop as Modal } from '@alfalab/core-components-modal/desktop';
import { TextHolder } from '@alfa-bank/site-text-holder';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';

import { Header as Component } from '../header';
import type { THeaderProps, IHeaderDeps } from '../models';
import styles from '../../../modal/desktop/desktop.css';

export const ModalV2HeaderDesktop = createWidget<IHeaderDeps, THeaderProps>({
    Modal,
    Text: TextDesktop,
    TextHolder,
    styles,
})(Component);
